import { OidcUserStatus } from '@axa-fr/react-oidc';
import { LoadingAnimation, useOidcContext } from '@uag/react-core';
import { RequestType } from '@uag/welcome-shared/src/api/models';
import { useGetRequests } from '@uag/welcome-shared/src/api/queries/requests/requests';
import { Navigate } from 'react-router';

export const Home = () => {
    const { userLoadingState } = useOidcContext();

    const { data: requestsResponse, isLoading: isRequestsLoading } = useGetRequests({
        requestTypes: [RequestType.NonDoka360],
    });

    if (userLoadingState === OidcUserStatus.Loading || isRequestsLoading) {
        return <LoadingAnimation />;
    }

    const requests = requestsResponse?.data;

    if (!requests || requests.length <= 0) {
        return <Navigate to="/requests/create" />;
    }

    if (requests.length === 1) {
        return <Navigate to={`/requests/${requests[0].id}`} />;
    }

    return <Navigate to="/requests" />;
};
